import React,{Component} from 'react'
import styled from 'styled-components'
import fire from '../database/firebase'

const Styles = styled.div  `

    // - - HEADER - - //

.register:after {
    content: "";
    display: table;
    clear: both;
}

.registerLeft {
    float: left;
    width: 50%;
    text-align: center;
}

.registerRight {
    float: left;
    width: 50%;
    text-align: center;
}


`

export default class SignUp extends Component {
    constructor() {
        super()
        this.state = {

        }
    }

    render () {
        return(
            <Styles>
                <div className='register'>
                    <div className='registerLeft'>
                        <h1>Create your account</h1>
                    </div>
                    <div className='registerRight'>

                    </div>
                </div>
            </Styles>
        )
    }
}